import React, { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import HsnAndTaxTable from "./HsnAndTaxTable";
import JournalEntry from "./JournalEntry";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import InvoiceJournalEntryModal from "../Modals/InvoiceJournalEntryModal";
import { MoneyFormatv3 } from "../../../library/MoneyFormat";
import { useSelector } from "react-redux";
import { useStateList } from "./HandleInvoiceStateProvider";
function HsnandJournalTab({
  Type,
}) {
  const {
    data,
    setData,
    accNames,
    totTaxAmt,

    totGSTCess,

    totNetAmt,

    totGST,

    companyState,

    netAmountToPay,

    invTransArr,
    setInvTransArr,
    paymentTransArr,
    setPaymentTransArr,

    partyNameOptions,

    registrationType,

    tabvalue,
    setTabValue,

    partyType,

    items,

    nonItems,
  } = useStateList();
  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  let companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
  const [journalEntry, setJournalEntry] = useState([]);
  const [totCdtAmt, setTotCdtAmt] = useState(0);
  const [totDbtAmt, setTotDbtAmt] = useState(0);
  const [openJournalEntry, setOpenJournalEntry] = useState(false);
  function displayJournalEntry() {
    let journalArr = [];
    let journalInvArr = [];
    let journalTransArr = [];
    let aacArr = [];
    let journalGstArr = [];
    const itemuniqueIds = [];
    let roundOffArr = [];
    let AdditionalRoundOffArr=[];
    let tempArr = [];
    const taxTypes =
      partyType === "CUSTOMER" || Type === "Pos"
        ? [2, 3, 5, 4, 7, 9]
        : [2, 3, 5, 7, 9];
    let itemArr = items.map((ele) => {
      ele.itemWiseFlag = true;
      return ele;
    });
    let nonItemArr = nonItems.map((ele) => {
      ele.itemWiseFlag = false;
      return ele;
    });

    let itemNonItemArr = [...itemArr, ...nonItemArr];

    let totCreditAmount = 0;
    let totDebitAmount = 0;
    let grandTotal = 0;

    if (data.roundOff !== 0) {
      if (Type === "Sales" || Type === "DebitNote" || Type === "Pos") {
        if (data.roundOff < 0) {
          roundOffArr.push({
            accountName: "Roundoff Expenses",
            accountId: 31,
            debitAmt: Number(data.roundOff) * -1,
            creditAmt: 0,
          });
        } else {
          roundOffArr.push({
            accountName: "Roundoff Expenses",
            accountId: 31,
            creditAmt: Number(data.roundOff),
            debitAmt: 0,
          });
        }
      }
      if (Type === "Purchase" || Type === "CreditNote") {
        if (data.roundOff < 0) {
          roundOffArr.push({
            accountName: "Roundoff Expenses",
            accountId: 31,
            debitAmt: 0,
            creditAmt: Number(data.roundOff) * -1,
          });
        } else {
          roundOffArr.push({
            accountName: "Roundoff Expenses",
            accountId: 31,
            creditAmt: 0,
            debitAmt: Number(data.roundOff),
          });
        }
      }
    }
    const itemUnique = itemNonItemArr.filter((element) => {
      const isDuplicate = itemuniqueIds.includes(element?.ledgerAccount?.value);
      if (!isDuplicate) {
        itemuniqueIds.push(element?.ledgerAccount?.value);

        tempArr.push({
          amountTaxable: Number(element.taxableAMount),
          IGST: Number(element.IGST),
          GSTCess: Number(element.GSTCess),
          netAmount:
            Number(element?.taxableAMount) +
            Number(element.IGST) +
            Number(element.GSTCess),

          ledgerAccount: {
            label: element?.ledgerAccount?.label,
            value: element?.ledgerAccount?.value,
          },
          editable: element.editable,
          itemWiseFlag: element?.itemWiseFlag,
        });
        return true;
      } else {
        tempArr.map((item) => {
          if (element?.ledgerAccount?.value == item?.ledgerAccount?.value) {
            item.amountTaxable += Number(element.taxableAMount);
            item.IGST += Number(element.IGST);
            item.GSTCess += Number(element.GSTCess);
            item.netAmount = Number(item.amountTaxable)+Number(item.IGST)+Number(item.GSTCess);
          }
        });
      }
      return false;
    });
    if (
      Type === "Sales" ||
      Type === "Pos" ||
      (Type === "DebitNote" && partyType === "CUSTOMER")
    ) {
      tempArr.map((ele) => {
        aacArr.push({
          accountName: ele.ledgerAccount.label,
          accountId: ele?.ledgerAccount?.value,
          debitAmt: 0,
          creditAmt: Number(ele.amountTaxable),
        });
      });
    }
    if (
      Type === "Purchase" ||
      (Type === "CreditNote" && partyType === "SUPPLIER")
    ) {
      tempArr.map((ele) => {
        aacArr.push({
          accountName: ele.ledgerAccount.label,
          accountId: ele?.ledgerAccount?.value,
          creditAmt: 0,
          debitAmt:
            companyType == 3
              ? Number(ele.netAmount)
              : Number(ele.amountTaxable),
        });
      });
    }

    if (Type === "DebitNote" && partyType === "SUPPLIER") {
      tempArr.map((ele) => {
        ele.ledgerAccount =
          ele?.itemWiseFlag === true
            ? { label: "Purchase Return A/c", value: 14 }
            : ele?.ledgerAccount;
        aacArr.push({
          accountName: ele?.ledgerAccount?.label,
          accountId: ele?.ledgerAccount?.value,
          debitAmt: 0,
          creditAmt:
            companyType == 3
              ? Number(ele.netAmount)
              : Number(ele.amountTaxable),
        });
      });

      
    }

    if (Type === "CreditNote" && partyType === "CUSTOMER") {
      tempArr.map((ele) => {
        ele.ledgerAccount =
          ele?.itemWiseFlag === true
            ? { label: "Sales return A/c", value: 18 }
            : ele?.ledgerAccount;
        aacArr.push({
          accountName: ele?.ledgerAccount?.label,
          accountId: ele?.ledgerAccount?.value,
          debitAmt: Number(ele.amountTaxable),
          creditAmt: 0,
        });
      });
    }

    if (Type === "Sales" || Type === "Pos") {
      grandTotal =
        (data.reverseChargeFlag === 0
          ? Number(totTaxAmt + Number(totGSTCess) + Number(totGST))
          : Number(totTaxAmt)) +
        Number(data.tcsAmount) -
        Number(
          data.adjustmentsType === "1"
            ? (Number(totNetAmt) * Number(data.adjustments)) / 100
            : Number(data.adjustments)
        );
    }
    if (Type === "Purchase") {
      grandTotal =
        (data.reverseChargeFlag === 0
          ? Number(totTaxAmt + Number(totGSTCess) + Number(totGST))
          : Number(totTaxAmt)) -
        Number(data.tdsAmount) +
        Number(data.tcsAmount) -
        Number(
          data.adjustmentsType === "1"
            ? (Number(totNetAmt) * Number(data.adjustments)) / 100
            : Number(data.adjustments)
        );
    }
    if (Type === "Sales" || Type === "Pos" || (Type==="DebitNote" && partyType==="CUSTOMER")) {
      if (registrationType !== 3) {
        if (data.placeOfSupply.value == companyState) {
          if (
            // EInvoiceFlag &&
            partyType === "CUSTOMER" &&
            data?.partyCategory === "SEZ"
          ) {
            journalGstArr.push(
              {
                accountName: "IGST Output A/c",
                accountId: 11,
                debitAmt: 0,
                creditAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGST),
              },
              {
                accountName: "GST Output Cess A/c",
                accountId: 9,
                debitAmt: 0,
                creditAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGSTCess),
              }
            );
          } else {
            journalGstArr.push(
              {
                accountName: "CGST Output A/c",
                accountId: 5,
                debitAmt: 0,
                creditAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGST) / 2,
              },
              {
                accountName: "SGST Output A/c",
                accountId: 20,
                debitAmt: 0,
                creditAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGST) / 2,
              },
              {
                accountName: "GST Output Cess A/c",
                accountId: 9,
                debitAmt: 0,
                creditAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGSTCess),
              }
            );
          }
        } else {
           //LEDX-4126,LEDX-4505
          if(partyType==="CUSTOMER" && data?.placeOfSupply.value===96){
            journalGstArr.push(
              {
                accountName: "IGST Output A/c",
                accountId: 11,
                debitAmt: 0,
                creditAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGST),
              },
              {
                accountName: "IGST Refund Receivable A/c",
                accountId: 66,
                creditAmt: 0,
                debitAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGST),
              },
              {
                accountName: "GST Cess Refund Receivable A/c",
                accountId: 67,
                creditAmt: 0,
                debitAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  :Number(totGSTCess),
              },
              {
                accountName: "GST Output Cess A/c",
                accountId: 9,
                debitAmt: 0,
                creditAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGSTCess),
              }
            );
          } //LEDX-4126,LEDX-4505
          else{
          journalGstArr.push(
            {
              accountName: "IGST Output A/c",
              accountId: 11,
              debitAmt: 0,
              creditAmt: taxTypes.includes(data?.taxability?.value)
                ? 0
                : Number(totGST),
            },
            {
              accountName: "GST Output Cess A/c",
              accountId: 9,
              debitAmt: 0,
              creditAmt: taxTypes.includes(data?.taxability?.value)
                ? 0
                : Number(totGSTCess),
            }
          );
        }
      }
      } else {
        if (companyType == 3 
          // && data?.partyCategory === "RBCS"   changes on LEDX-4353-Composition
        ) {
          journalGstArr.push(
            {
              accountName: "CGST Composition Tax Payable A/c",
              accountId: 64,
              debitAmt: 0,
              creditAmt: taxTypes.includes(data?.taxability?.value)
                ? 0
                : Number(totGST) / 2 + Number(totGSTCess),
            },

            {
              accountName: "SGST Composition Tax Payable A/c",
              accountId: 65,
              debitAmt: 0,
              creditAmt: taxTypes.includes(data?.taxability?.value)
                ? 0
                : Number(totGST) / 2 + Number(totGSTCess),
            },
            {
              accountName: "Composition Tax Paid A/c",
              accountId: 33,
              debitAmt: taxTypes.includes(data?.taxability?.value)
                ? 0
                : Number(totGST) + Number(totGSTCess),
              creditAmt: 0,
            }
          );
        }
        ///changes on  LEDX-435-Composition
        //  else {
        //   journalGstArr.push(
        //     {
        //       accountName: "Composition Tax Payable A/c",
        //       accountId: 32,
        //       debitAmt: 0,
        //       creditAmt: taxTypes.includes(data?.taxability?.value)
        //         ? 0
        //         : Number(totGST) + Number(totGSTCess),
        //     },
        //     {
        //       accountName: "Composition Tax Paid A/c",
        //       accountId: 33,
        //       debitAmt: taxTypes.includes(data?.taxability?.value)
        //         ? 0
        //         : Number(totGST) + Number(totGSTCess),
        //       creditAmt: 0,
        //     }
        //   );
        // }
      }
      journalInvArr.push(
        {
          accountName: Type === "Pos" ? "" : data?.partyName?.ledgerName,
          accountId: Type === "Pos" ? 0 : data.partyName.accountsID,
          // debitAmt: data.reverseChargeFlag === 1 ? Number(netAmountToPay - totGST) : Number(netAmountToPay),
          debitAmt: Type === "Pos" ? 0:
           //LEDX-4126,LEDX-4505
          partyType==="CUSTOMER" && data?.placeOfSupply?.value===96?
          // Number(totTaxAmt)
          Number(netAmountToPay-totGST-totGSTCess)
           //LEDX-4126,LEDX-4505
           : Number(netAmountToPay),
          creditAmt: 0,
        },

        {
          accountName: "Discount/Additions",
          accountId: 15,
          debitAmt: Number(data.adjustments),
          creditAmt: 0,
        },
        {
          accountName: "TCS Payable A/c",
          accountId: 26,
          debitAmt: 0,
          creditAmt: Number(data.tcsAmount),
        },
        {
          accountName: Type === "Pos" ? data.receivedAccount.label : "",
          accountId: Type === "Pos" ? data.receivedAccount.value : 0,
          debitAmt: Type === "Pos" ? Number(data.receivedAmount) : 0,
          creditAmt: 0,
        },
        {
          accountName: Type === "Pos" ? data?.bankReceivedAccount?.label : "",
          accountId: Type === "Pos" ? data?.bankReceivedAccount?.value : 0,
          debitAmt: Type === "Pos" ? Number(data?.bankReceivedAmount) : 0,
          creditAmt: 0,
        }
      );

      journalTransArr.push(
        {
          accountName:
            Type === "Sales" ? data?.partyName?.ledgerName : "Sales A/c",
          accountId: Type === "Sales" ? data.partyName.accountsID : 17,
          debitAmt: 0,
          creditAmt: Number(data.receivedAmount),
        },
        {
          accountName: data.receivedAccount.label,
          accountId: data.receivedAccount.value,
          debitAmt: Number(data.receivedAmount),
          creditAmt: 0,
        }
      );
      if (Type === "Pos") {
        journalArr = [
          ...aacArr,
          ...journalInvArr,
          ...journalGstArr,
          ...roundOffArr,
        ];
      } else {
        journalArr = [
          ...aacArr,
          ...journalInvArr,
          ...journalGstArr,
          ...roundOffArr,
          ...journalTransArr,
        ];
      }
    }
    if (
      Type === "Purchase" ||
      (Type === "CreditNote" && partyType === "SUPPLIER")
    ) {
      // if (registrationType !== 3) {
      if (data.placeOfSupply.value == companyState) {
        if (
          // EInvoiceFlag &&
          partyType === "SUPPLIER" &&
          data?.partyCategory === "SEZ"
        ) {
          journalGstArr.push(
            {
              accountName:
                data.reverseChargeFlag === 1
                  ? "IGST RCM Input A/c"
                  : "IGST Input A/c",
              accountId: data.reverseChargeFlag === 1 ? 60 : 10,
              creditAmt: 0,
              debitAmt: companyType == 3 ? 0 : Number(totGST),
            },
            //Reverse Charge Flag
            {
              accountName:
                data.reverseChargeFlag === 1
                  ? "IGST RCM Output A/c"
                  : "IGST Output A/c",
              accountId: data.reverseChargeFlag === 1 ? 56 : 11,
              creditAmt: data.reverseChargeFlag === 1 ? Number(totGST) : 0,
              debitAmt: 0,
            },

            //Reverse Charge Flag
            {
              accountName:
                data.reverseChargeFlag === 1
                  ? "GST RCM Input Cess A/c"
                  : "GST Input Cess A/c",
              accountId: data.reverseChargeFlag === 1 ? 63 : 7,
              creditAmt: 0,
              debitAmt: companyType == 3 ? 0 : Number(totGSTCess),
            },
            {
              accountName:
                data.reverseChargeFlag === 1
                  ? "GST RCM Output Cess A/c"
                  : "GST Output Cess A/c",
              accountId: data.reverseChargeFlag === 1 ? 59 : 9,
              creditAmt: data.reverseChargeFlag === 1 ? Number(totGSTCess) : 0,
              debitAmt: 0,
            }
          );
        } else {
          journalGstArr.push(
            {
              accountName:
                data.reverseChargeFlag === 1
                  ? "CGST RCM Input A/c"
                  : "CGST Input A/c",
              accountId: data.reverseChargeFlag === 1 ? 61 : 4,
              creditAmt: 0,
              debitAmt: companyType == 3 ? 0 : Number(totGST) / 2,
            },
            {
              accountName:
                data.reverseChargeFlag === 1
                  ? "SGST RCM Input A/c"
                  : "SGST Input A/c",
              accountId: data.reverseChargeFlag === 1 ? 62 : 19,
              creditAmt: 0,
              debitAmt: companyType == 3 ? 0 : Number(totGST) / 2,
            },
            //Reverse Charge Flag
            {
              accountName:
                data.reverseChargeFlag === 1
                  ? "CGST RCM Output A/c"
                  : "CGST Output A/c",

              accountId: data.reverseChargeFlag === 1 ? 57 : 5,
              creditAmt: data.reverseChargeFlag === 1 ? Number(totGST) / 2 : 0,
              debitAmt: 0,
            },
            {
              accountName:
                data.reverseChargeFlag === 1
                  ? "SGST RCM Output A/c"
                  : "SGST Output A/c",
              accountId: data.reverseChargeFlag === 1 ? 58 : 20,
              creditAmt: data.reverseChargeFlag === 1 ? Number(totGST) / 2 : 0,
              debitAmt: 0,
            },
            {
              accountName:
                data.reverseChargeFlag === 1
                  ? "GST RCM Output Cess A/c"
                  : "GST Output Cess A/c",
              accountId: data.reverseChargeFlag === 1 ? 59 : 9,
              creditAmt: data.reverseChargeFlag === 1 ? Number(totGSTCess) : 0,
              debitAmt: 0,
            },
            //Reverse Charge Flag
            {
              accountName:
                data.reverseChargeFlag === 1
                  ? "GST RCM Input Cess A/c"
                  : "GST Input Cess A/c",
              accountId: data.reverseChargeFlag === 1 ? 63 : 7,
              creditAmt: 0,
              debitAmt: companyType == 3 ? 0 : Number(totGSTCess),
            }
          );
        }
      } else {
        journalGstArr.push(
          {
            accountName:
              data.reverseChargeFlag === 1
                ? "IGST RCM Input A/c"
                : "IGST Input A/c",
            accountId: data.reverseChargeFlag === 1 ? 60 : 10,
            creditAmt: 0,
            debitAmt: Number(totGST),
          },
          //Reverse Charge Flag
          {
            accountName:
              data.reverseChargeFlag === 1
                ? "IGST RCM Output A/c"
                : "IGST Output A/c",
            accountId: data.reverseChargeFlag === 1 ? 56 : 11,
            creditAmt: data.reverseChargeFlag === 1 ? Number(totGST) : 0,
            debitAmt: 0,
          },
          {
            accountName:
              data.reverseChargeFlag === 1
                ? "GST RCM Output Cess A/c"
                : "GST Output Cess A/c",
            accountId: data.reverseChargeFlag === 1 ? 59 : 9,
            creditAmt: data.reverseChargeFlag === 1 ? Number(totGSTCess) : 0,
            debitAmt: 0,
          },

          //Reverse Charge Flag
          {
            accountName:
              data.reverseChargeFlag === 1
                ? "GST RCM Input Cess A/c"
                : "GST Input Cess A/c",
            accountId: data.reverseChargeFlag === 1 ? 63 : 7,
            creditAmt: 0,
            debitAmt: Number(totGSTCess),
          }
        );
      }
      // }

      journalInvArr.push(
        {
          accountName: data?.partyName?.ledgerName,
          accountId: data?.partyName?.accountsID,
          //Rework/LEDX-4673
          // creditAmt:
          //   companyType == 3
          //     ? data.reverseChargeFlag === 1
          //       ? Number(netAmountToPay)
          //       : Number(netAmountToPay + Number(totGSTCess) + Number(totGST))
          //     : data.reverseChargeFlag === 1 && companyType != 3
          //     ? Number(netAmountToPay - totGST - totGSTCess)
          //     : Number(netAmountToPay),
          //Rework/LEDX-4673
           creditAmt:
            companyType == 3
              ? data.reverseChargeFlag === 1
                ? Number(netAmountToPay-totGST-totGSTCess)
                : Number(netAmountToPay )
              : data.reverseChargeFlag === 1 && companyType != 3
              ? Number(netAmountToPay - totGST - totGSTCess)
              : Number(netAmountToPay),
          debitAmt: 0,
        },

        {
          accountName: "TDS Payable A/c",
          accountId: 21,
          debitAmt: 0,
          creditAmt: Number(data.tdsAmount),
        },
        {
          accountName: "TCS Receivable A/c",
          accountId: 30,
          creditAmt: 0,
          debitAmt: Number(data.tcsAmount),
        },
        {
          accountName: "Discount/Additions",
          accountId: 15,
          creditAmt: Number(data.adjustments),
          debitAmt: 0,
        }
      );
      journalTransArr.push(
        {
          accountName: data.receivedAccount.label,
          accountId: data?.receivedAccount?.value,
          creditAmt: Number(data.receivedAmount),
          debitAmt: 0,
        },
        {
          accountName: data?.partyName?.ledgerName,
          accountId: data?.partyName?.accountsID,
          creditAmt: 0,
          debitAmt: Number(data.receivedAmount),
        }
      );
      journalArr = [
        ...aacArr,
        ...journalGstArr,
        ...journalInvArr,
        ...roundOffArr,
        ...journalTransArr,
      ];
    }

    // if (Type === "DebitNote" && partyType === "CUSTOMER") {
    //   if (registrationType !== 3) {
    //     if (data.placeOfSupply.value == companyState) {
    //       if (
    //         // EInvoiceFlag &&
    //         partyType === "CUSTOMER" &&
    //         data?.partyCategory === "SEZ"
    //       ) {
    //         journalGstArr.push(
    //           {
    //             accountName: "IGST Output A/c",
    //             accountId: 11,
    //             debitAmt: 0,
    //             creditAmt: taxTypes.includes(data?.taxability?.value)
    //               ? 0
    //               : Number(totGST),
    //           },
    //           {
    //             accountName: "GST Output Cess A/c",
    //             accountId: 9,
    //             debitAmt: 0,
    //             creditAmt: taxTypes.includes(data?.taxability?.value)
    //               ? 0
    //               : Number(totGSTCess),
    //           }
    //         );
    //       } else {
    //         journalGstArr.push(
    //           {
    //             accountName: "CGST Output A/c",
    //             accountId: 5,
    //             debitAmt: 0,
    //             creditAmt: taxTypes.includes(data?.taxability?.value)
    //               ? 0
    //               : Number(totGST) / 2,
    //           },
    //           {
    //             accountName: "SGST Output A/c",
    //             accountId: 20,
    //             debitAmt: 0,
    //             creditAmt: taxTypes.includes(data?.taxability?.value)
    //               ? 0
    //               : Number(totGST) / 2,
    //           },
    //           {
    //             accountName: "GST Output Cess A/c",
    //             accountId: 9,
    //             debitAmt: 0,
    //             creditAmt: taxTypes.includes(data?.taxability?.value)
    //               ? 0
    //               : Number(totGSTCess),
    //           }
    //         );
    //       }
    //     } else {
    //       journalGstArr.push(
    //         {
    //           accountName: "IGST Output A/c",
    //           accountId: 11,
    //           debitAmt: 0,
    //           creditAmt: taxTypes.includes(data?.taxability?.value)
    //             ? 0
    //             : Number(totGST),
    //         },
    //         {
    //           accountName: "GST Output Cess A/c",
    //           accountId: 9,
    //           debitAmt: 0,
    //           creditAmt: taxTypes.includes(data?.taxability?.value)
    //             ? 0
    //             : Number(totGSTCess),
    //         }
    //       );
    //     }
    //   }

    //   journalInvArr.push(
    //     {
    //       accountName: data?.partyName?.ledgerName,
    //       accountId: data?.partyName?.accountsID,
    //       debitAmt: Number(netAmountToPay),
    //       creditAmt: 0,
    //     },

    //     {
    //       accountName: "Discount/Additions",
    //       accountId: 15,
    //       debitAmt: Number(data.adjustments),
    //       creditAmt: 0,
    //     },
    //     {
    //       accountName: "TCS Payable A/c",
    //       accountId: 26,
    //       debitAmt: 0,
    //       creditAmt: Number(data.tcsAmount),
    //     }
    //   );
    //   journalTransArr.push(
    //     {
    //       accountName: data?.partyName?.ledgerName,
    //       accountId: data?.partyName?.accountsID,
    //       debitAmt: 0,
    //       creditAmt: Number(data.receivedAmount),
    //     },
    //     {
    //       accountName: data?.receivedAccount?.label,
    //       accountId: data?.receivedAccount?.value,
    //       debitAmt: Number(data.receivedAmount),
    //       creditAmt: 0,
    //     }
    //   );
    //   journalArr = [
    //     ...aacArr,
    //     ...journalInvArr,
    //     ...journalGstArr,
    //     ...roundOffArr,
    //     ...journalTransArr,
    //   ];
    // }
    if (Type === "DebitNote" && partyType === "SUPPLIER") {
      if (registrationType !== 3) {
        if (data.placeOfSupply.value == companyState) {
          if (
            // EInvoiceFlag &&
            partyType === "SUPPLIER" &&
            data?.partyCategory === "SEZ"
          ) {
            journalGstArr.push(
              {
                accountName:
                  data.reverseChargeFlag === 1
                    ? "IGST RCM Input A/c"
                    : "IGST Input A/c",
                accountId: data.reverseChargeFlag === 1 ? 60 : 10,
                debitAmt: 0,
                creditAmt: Number(totGST),
              },
              {
                accountName:
                  data.reverseChargeFlag === 1
                    ? "GST RCM Input Cess A/c"
                    : "GST Input Cess A/c",
                accountId: data.reverseChargeFlag === 1 ? 63 : 7,
                debitAmt: 0,
                creditAmt: Number(totGSTCess),
              }
            );
          } else {
            journalGstArr.push(
              {
                accountName:
                  data.reverseChargeFlag === 1
                    ? "CGST RCM Input A/c"
                    : "CGST Input A/c",
                accountId: data.reverseChargeFlag === 1 ? 61 : 4,
                debitAmt: 0,
                creditAmt: Number(totGST) / 2,
              },
              {
                accountName:
                  data.reverseChargeFlag === 1
                    ? "SGST RCM Input A/c"
                    : "SGST Input A/c",
                accountId: data.reverseChargeFlag === 1 ? 62 : 19,
                debitAmt: 0,

                creditAmt: Number(totGST) / 2,
              },
              {
                accountName:
                  data.reverseChargeFlag === 1
                    ? "GST RCM Input Cess A/c"
                    : "GST Input Cess A/c",
                accountId: data.reverseChargeFlag === 1 ? 63 : 7,
                debitAmt: 0,
                creditAmt: Number(totGSTCess),
              }
            );
          }
        } else {
          journalGstArr.push(
            {
              accountName:
                data.reverseChargeFlag === 1
                  ? "IGST RCM Input A/c"
                  : "IGST Input A/c",
              accountId: data.reverseChargeFlag === 1 ? 60 : 10,

              debitAmt: 0,
              creditAmt: Number(totGST),
            },
            {
              accountName:
                data.reverseChargeFlag === 1
                  ? "GST RCM Input Cess A/c"
                  : "GST Input Cess A/c",

              accountId: data.reverseChargeFlag === 1 ? 63 : 7,
              debitAmt: 0,
              creditAmt: Number(totGSTCess),
            }
          );
        }
      } else {
        journalGstArr.push(
          {
            accountName:
              data.reverseChargeFlag === 1
                ? "IGST RCM Output A/c"
                : "IGST Output A/c",
            accountId: data.reverseChargeFlag === 1 ? 56 : 11,
            creditAmt: 0,
            debitAmt: data.reverseChargeFlag === 1 ? Number(totGST) : 0,
          },
          {
            accountName:
              data.reverseChargeFlag === 1
                ? "GST RCM Output Cess A/c"
                : "GST Output Cess A/c",
            accountId: data.reverseChargeFlag === 1 ? 59 : 9,
            creditAmt: 0,
            debitAmt: data.reverseChargeFlag === 1 ? Number(totGSTCess) : 0,
          }
        );
      }
      // else{
      //   journalGstArr.push(
      //     {
      //       accountName: "Composition Tax Payable A/c",accountId:32,
      //       debitAmt: 0,
      //       creditAmt: Number(totGST)+Number(totGSTCess),
      //     },
      //     {
      //       accountName: "Composition Tax Paid A/c",accountId:33,
      //       debitAmt: Number(totGST)+Number(totGSTCess),
      //       creditAmt: 0,
      //     },
      //   )
      // }
      journalInvArr.push(
        {
          accountName: data?.partyName?.ledgerName,
          accountId: data?.partyName?.accountsID,
          //Rework/LEDX-4673
          // debitAmt:
          //   companyType == 3
          //     ? (data?.reverseChargeFlag == 1
          //       ? Number(netAmountToPay)
          //       : Number(netAmountToPay) + Number(totGST) + Number(totGSTCess))
          //     : Number(netAmountToPay),
          //Rework/LEDX-4673
           debitAmt:
            companyType == 3
              ? (data?.reverseChargeFlag == 1
                ? Number(netAmountToPay-totGST-totGSTCess)
                : Number(netAmountToPay))
              : Number(netAmountToPay),
          creditAmt: 0,
        },

        {
          accountName: "Discount/Additions",
          accountId: 15,
          debitAmt: Number(data.adjustments),
          creditAmt: 0,
        },
        {
          accountName: "TCS Receivable A/c",
          accountId: 30,
          debitAmt: 0,
          creditAmt: Number(data.tcsAmount),
        },
        {
          accountName: "TDS Payable A/c",
          accountId: 21,
          debitAmt: Number(data.tdsAmount),
          creditAmt: 0,
        }
      );
      journalTransArr.push(
        {
          accountName: data?.partyName?.ledgerName,
          accountId: data?.partyName?.accountsID,
          debitAmt: 0,
          creditAmt: Number(data.receivedAmount),
        },
        {
          accountName: data.receivedAccount.label,
          accountId: data?.receivedAccount?.value,
          debitAmt: Number(data.receivedAmount),
          creditAmt: 0,
        }
      );
      journalArr = [
        ...aacArr,
        ...journalInvArr,
        ...journalGstArr,
        ...roundOffArr,
        ...journalTransArr,
      ];
    }

    if (Type === "CreditNote" && partyType === "CUSTOMER") {
      if (registrationType !== 3) {
        if (data.placeOfSupply.value == companyState) {
          if (
            // EInvoiceFlag &&
            partyType === "CUSTOMER" &&
            data?.partyCategory === "SEZ"
          ) {
            journalGstArr.push(
              {
                accountName: "IGST Output A/c",
                accountId: 11,
                creditAmt: 0,
                debitAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGST),
              },
              {
                accountName: "GST Output Cess A/c",
                accountId: 9,
                creditAmt: 0,
                debitAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGSTCess),
              }
            );
          } else {
            journalGstArr.push(
              {
                accountName: "CGST Output A/c",
                accountId: 5,
                creditAmt: 0,
                debitAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGST) / 2,
              },
              {
                accountName: "SGST Output A/c",
                accountId: 20,
                creditAmt: 0,
                debitAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGST) / 2,
              },
              {
                accountName: "GST Output Cess A/c",
                accountId: 9,
                creditAmt: 0,
                debitAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGSTCess),
              }
            );
          }
        } else {
          //LEDX-4126,LEDX-4505
          if(partyType==="CUSTOMER" && data?.placeOfSupply?.value===96){
            journalGstArr.push(
              
              {
                accountName: "IGST Refund Receivable A/c",
                accountId: 66,
                debitAmt: 0,
                creditAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGST),
              },
              {
                accountName: "GST Cess Refund Receivable A/c",
                accountId: 67,
                debitAmt: 0,
                creditAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  :Number(totGSTCess),
              },
           
              {
                accountName: "IGST Output A/c",
                accountId: 11,
                creditAmt: 0,
                debitAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGST),
              },
              {
                accountName: "GST Output Cess A/c",
                accountId: 9,
                creditAmt: 0,
                debitAmt: taxTypes.includes(data?.taxability?.value)
                  ? 0
                  : Number(totGSTCess),
              }
            );
          }  //LEDX-4126,LEDX-4505
          else{
          journalGstArr.push(
           
            {
              accountName: "IGST Output A/c",
              accountId: 11,
              creditAmt: 0,
              debitAmt: taxTypes.includes(data?.taxability?.value)
                ? 0
                : Number(totGST),
            },
            {
              accountName: "GST Output Cess A/c",
              accountId: 9,
              creditAmt: 0,
              debitAmt: taxTypes.includes(data?.taxability?.value)
                ? 0
                : Number(totGSTCess),
            }
          );
        }
      }
      } else {
        journalGstArr.push(
          // changes on LEDX-4353-Composition 
          // {
          //   accountName: "Composition Tax Payable A/c",
          //   accountId: 32,
          //   debitAmt: taxTypes.includes(data?.taxability?.value)
          //   ? 0
          //   : Number(totGST) + Number(totGSTCess),
          //   creditAmt:0 ,
          // },
          {
            accountName: "CGST Composition Tax Payable A/c",
            accountId: 64,
            debitAmt: taxTypes.includes(data?.taxability?.value)
            ? 0
            : Number(totGST) / 2 + Number(totGSTCess),
            creditAmt: 0,
           
          },

          {
            accountName: "SGST Composition Tax Payable A/c",
            accountId: 65,
            debitAmt: taxTypes.includes(data?.taxability?.value)
              ? 0
              : Number(totGST) / 2 + Number(totGSTCess),
            creditAmt: 0,
            
          },
          {
            accountName: "Composition Tax Paid A/c",
            accountId: 33,
            debitAmt:0,
            creditAmt:taxTypes.includes(data?.taxability?.value)
            ? 0
            : Number(totGST) + Number(totGSTCess),
          }
        );
      }
      journalInvArr.push(
        {
          accountName: data?.partyName?.ledgerName,
          accountId: data?.partyName?.accountsID,
          creditAmt:
           //LEDX-4126,LEDX-4505
          partyType==="CUSTOMER" && data?.placeOfSupply?.value===96 ?
          // Number(totTaxAmt)
           Number(netAmountToPay-totGST-totGSTCess)
           //LEDX-4126,LEDX-4505
          : Number(netAmountToPay),
          debitAmt: 0,
        },

        {
          accountName: "TCS Payable A/c",
          accountId: 26,
          creditAmt: 0,
          debitAmt: Number(data.tcsAmount),
        },
        {
          accountName: "Discount/Additions",
          accountId: 15,
          creditAmt: Number(data.adjustments),
          debitAmt: 0,
        }
      );
      journalTransArr.push(
        {
          accountName: data.receivedAccount.label,
          accountId: data?.receivedAccount?.value,
          creditAmt: Number(data.receivedAmount),
          debitAmt: 0,
        },
        {
          accountName: data?.partyName?.ledgerName,
          accountId: data?.partyName?.accountsID,
          creditAmt: 0,
          debitAmt: Number(data.receivedAmount),
        }
      );
      journalArr = [
        ...aacArr,
        ...journalGstArr,
        ...journalInvArr,
        ...roundOffArr,
        ...journalTransArr,
      ];
    }
    // if (Type === "CreditNote" && partyType === "SUPPLIER") {
    //   if (registrationType !== 3) {
    //     if (data.placeOfSupply.value == companyState) {
    //       if (
    //         // EInvoiceFlag &&
    //         partyType === "SUPPLIER" &&
    //         data?.partyCategory === "SEZ"
    //       ) {
    //         journalGstArr.push(
    //           {
    //             accountName:
    //               data.reverseChargeFlag === 1
    //                 ? "IGST RCM Input A/c"
    //                 : "IGST Input A/c",
    //             accountId: data.reverseChargeFlag === 1 ? 60 : 10,
    //             creditAmt: 0,
    //             debitAmt: Number(totGST),
    //           },
    //           {
    //             accountName:
    //               data.reverseChargeFlag === 1
    //                 ? "GST RCM Input Cess A/c"
    //                 : "GST Input Cess A/c",
    //             accountId: data.reverseChargeFlag === 1 ? 63 : 7,
    //             creditAmt: 0,
    //             debitAmt: Number(totGSTCess),
    //           }
    //         );
    //       } else {
    //         journalGstArr.push(
    //           {
    //             accountName:
    //               data.reverseChargeFlag === 1
    //                 ? "CGST RCM Input A/c"
    //                 : "CGST Input A/c",

    //             accountId: data.reverseChargeFlag === 1 ? 61 : 4,
    //             creditAmt: 0,
    //             debitAmt: Number(totGST) / 2,
    //           },
    //           {
    //             accountName:
    //               data.reverseChargeFlag === 1
    //                 ? "SGST RCM Input A/c"
    //                 : "SGST Input A/c",
    //             accountId: data.reverseChargeFlag === 1 ? 62 : 19,
    //             creditAmt: 0,
    //             debitAmt: Number(totGST) / 2,
    //           },
    //           {
    //             accountName:
    //               data.reverseChargeFlag === 1
    //                 ? "GST RCM Input Cess A/c"
    //                 : "GST Input Cess A/c",
    //             accountId: data.reverseChargeFlag === 1 ? 63 : 7,
    //             creditAmt: 0,
    //             debitAmt: Number(totGSTCess),
    //           }
    //         );
    //       }
    //     } else {
    //       journalGstArr.push(
    //         {
    //           accountName:
    //             data.reverseChargeFlag === 1
    //               ? "IGST RCM Input A/c"
    //               : "IGST Input A/c",
    //           accountId: data.reverseChargeFlag === 1 ? 60 : 10,
    //           creditAmt: 0,
    //           debitAmt: Number(totGST),
    //         },
    //         {
    //           accountName:
    //             data.reverseChargeFlag === 1
    //               ? "GST RCM Input Cess A/c"
    //               : "GST Input Cess A/c",
    //           accountId: data.reverseChargeFlag === 1 ? 63 : 7,
    //           creditAmt: 0,
    //           debitAmt: Number(totGSTCess),
    //         }
    //       );
    //     }
    //   } else {
    //     journalGstArr.push(
    //       {
    //         accountName: "Composition Tax Payable A/c",
    //         accountId: 32,
    //         debitAmt: 0,
    //         creditAmt: taxTypes.includes(data?.taxability?.value)
    //           ? 0
    //           : Number(totGST) + Number(totGSTCess),
    //       },
    //       {
    //         accountName: "Composition Tax Paid A/c",
    //         accountId: 33,
    //         debitAmt: taxTypes.includes(data?.taxability?.value)
    //           ? 0
    //           : Number(totGST) + Number(totGSTCess),
    //         creditAmt: 0,
    //       }
    //     );
    //   }
    //   journalInvArr.push(
    //     {
    //       accountName: data?.partyName?.ledgerName,
    //       accountId: data?.partyName?.accountsID,
    //       creditAmt: Number(netAmountToPay),
    //       debitAmt: 0,
    //     },

    //     {
    //       accountName: "TDS Payable A/c",
    //       accountId: 21,
    //       debitAmt: 0,
    //       creditAmt: Number(data.tdsAmount),
    //     },
    //     {
    //       accountName: "TCS Payable A/c",
    //       accountId: 26,
    //       creditAmt: 0,
    //       debitAmt: Number(data.tcsAmount),
    //     },
    //     {
    //       accountName: "Discount/Additions",
    //       accountId: 15,
    //       creditAmt: Number(data.adjustments),
    //       debitAmt: 0,
    //     }
    //   );
    //   journalTransArr.push(
    //     {
    //       accountName: data.receivedAccount.label,
    //       accountId: data?.receivedAccount?.value,
    //       creditAmt: Number(data.receivedAmount),
    //       debitAmt: 0,
    //     },
    //     {
    //       accountName: data?.partyName?.ledgerName,
    //       accountId: data?.partyName?.accountsID,
    //       creditAmt: 0,
    //       debitAmt: Number(data.receivedAmount),
    //     }
    //   );
    //   journalArr = [
    //     ...aacArr,
    //     ...journalGstArr,
    //     ...journalInvArr,
    //     ...roundOffArr,
    //     ...journalTransArr,
    //   ];
    // }

    journalArr.map((ele) => {
      totCreditAmount +=
        Number(ele.creditAmt).toFixed(2) * Number(data.currencyRate).toFixed(2);
      totDebitAmount +=
        Number(ele.debitAmt).toFixed(2) * Number(data.currencyRate).toFixed(2);
    });
    //LEDX-5530
       const diff = Number((totDebitAmount - totCreditAmount).toFixed(2));
    if (Math.abs(diff) === 0.01) {
  const roundOffValue = 0.01;

  if (totDebitAmount > totCreditAmount) {
    AdditionalRoundOffArr.push({
      accountName: "Roundoff Expenses (Auto JE)", 
      accountId: 31,
      debitAmt: 0,
      creditAmt:Number(roundOffValue),
    });
  } else if (totCreditAmount > totDebitAmount) {
    AdditionalRoundOffArr.push({
      accountName: "Roundoff Expenses (Auto JE)", 
      accountId: 31,
      debitAmt:  Number(roundOffValue),
      creditAmt: 0,
    });
  }
  journalArr = [...journalArr, ...AdditionalRoundOffArr];
    totCreditAmount += AdditionalRoundOffArr[0].creditAmt;
  totDebitAmount += AdditionalRoundOffArr[0].debitAmt;
}
//LEDX-5530
    let invTranArr = [];
    let paymentTransArr = [];
    const cleanNumber = (value) => {
      return Number(value.replace(/[^\d.-]/g, ""));
    };

    accNames.map((ele) => {
      [...aacArr, ...journalGstArr, ...journalInvArr, ...roundOffArr,...AdditionalRoundOffArr].map(
        (invEle) => {
          if (invEle.debitAmt !== 0 || invEle.creditAmt !== 0) {
            if (ele.value == invEle.accountId) {
              invTranArr.push({
                accID: ele.value,
                creditAmt: cleanNumber(
                  MoneyFormatv3(
                    Number(invEle.creditAmt).toFixed(2) *
                      Number(data.currencyRate)
                  )
                ),
                debitAmt: cleanNumber(
                  MoneyFormatv3(
                    Number(invEle.debitAmt).toFixed(2) *
                      Number(data.currencyRate)
                  )
                ),
                accountName: invEle.accountName,
                sortAmount:
                  invEle.creditAmt == 0 ? invEle.debitAmt : invEle.creditAmt,
              });
            }
          }
        }
      );
      journalTransArr.map((transEle) => {
        if (transEle.debitAmt !== 0 || transEle.creditAmt !== 0) {
          if (ele.label === transEle.accountName) {
            paymentTransArr.push({
              accID: ele.value,
              creditAmt: cleanNumber(
                MoneyFormatv3(
                  Number(transEle.creditAmt).toFixed(2) *
                    Number(data.currencyRate)
                )
              ),
              debitAmt: cleanNumber(
                MoneyFormatv3(
                  Number(transEle.debitAmt).toFixed(2) *
                    Number(data.currencyRate)
                )
              ),
              accountName: transEle.accountName,
            });
          }
        }
      });
    });

    setInvTransArr(invTranArr.sort((a, b) => b.sortAmount - a.sortAmount));
    setPaymentTransArr(paymentTransArr);
    // setTotCdtAmt(totCreditAmount);
    // setTotDbtAmt(totDebitAmount);
    setTotCdtAmt(Number(totCreditAmount.toFixed(2))); //LEDX-5530
setTotDbtAmt(Number(totDebitAmount.toFixed(2)));//LEDX-5530

    setJournalEntry(journalArr);
  }

  useEffect(() => {
    displayJournalEntry();
  }, [items, data, nonItems, partyNameOptions, accNames, totGST, totGSTCess]);
  useEffect(() => {
    if (registrationType === 1) {
      setTabValue("2");
    }
  }, [registrationType]);

  return (
    <Box
      sx={{
        flex: { xs: 1, lg: 0.5 },
        // mt: "3px",
        // borderRight: "1px solid black",
        border:{xs:"solid 1px gray",lg:"none"},
        borderColor: "input.label",
        height:
          Type == "Purchase" || partyType === "SUPPLIER"
            ? 380
            : Type === "Pos"
            ? "100%"
            : 300,
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Tabs
          sx={{ p: "5px" }}
          value={tabvalue}
          aria-label="basic tabs example"
        >
          {registrationType !== 1 && (
            <Tab
              sx={{
                fontSize: "14px",
                "&.MuiTab-root": {
                  fontWeight: "800px",
                },
              }}
              label="HSN/SAC Code Summary Table"
              onClick={(e) => {
                setTabValue("1");
              }}
              value={"1"}
            />
          )}
          <Tab
            sx={{
              fontSize: "14px",
              "&.MuiTab-root": {
                fontWeight: "800px",
              },
            }}
            label="Journal Entry"
            onClick={(e) => {
              setTabValue("2");
            }}
            value={"2"}
          />
        </Tabs>
        {tabvalue === "2" && (
          <>
            <Tooltip arrow title={"Expanded View"}>
              <span
                onClick={() => {
                  setOpenJournalEntry(true);
                }}
              >
                <AspectRatioIcon
                  sx={{
                    mr: 4,
                    mt: "22px",
                    color: "primary.main",
                    cursor: "pointer",
                    fontSize: "18px",
                    alignItems: "center",
                  }}
                />
              </span>
            </Tooltip>

            {data.currency.code !== "INR" && (
              <>
                <Typography
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    fontWeight: "bold",
                    alignItems: "center",
                    gap: "10px",
                    mt: "5px",
                    mr: "5px",
                  }}
                >
                  Current Rate {""} 1({data.currency.sign}) ={" "}
                  <TextField
                    error={
                      data.errorStatus.currencyRate === true ? true : false
                    }
                    label="Currency Rate"
                    size="small"
                    name="currencyRate"
                    required={
                      data.currencyRate === "" || data.currencyRate === 0
                        ? true
                        : false
                    }
                    value={data.currencyRate}
                    type="text"
                    onChange={(e) => {
                      let value = e.target.value;
                      value = value.replace(/,/g, "");
                      if (value === "0-") {
                        value = "-0";
                      }
                      if (value === "-") {
                        value = "0";
                      }
                      if (!/^(-?\d*(?:\.\d*)?)$/.test(value)) {
                        return;
                      }
                      if (value !== "") {
                        setData((prev) => ({
                          ...prev,
                          currencyRate: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            currencyRate: false,
                          },
                        }));
                      } else {
                        setData((prev) => ({
                          ...prev,
                          currencyRate: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            currencyRate: true,
                          },
                        }));
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      maxWidth: 180,
                      ".MuiFormLabel-asterisk": {
                        color: "danger.main",
                        fontSize: "16px",
                        fontWeight: "bold",
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CurrencyRupeeIcon fontSize="14px" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Typography>
              </>
            )}
          </>
        )}
      </Box>
      {tabvalue == "1" ? (
        <HsnAndTaxTable
          data={data}
          companyState={companyState}
          items={items}
          nonItems={nonItems}
          totTaxAmt={totTaxAmt}
          totNetAmt={totNetAmt}
          totGST={totGST}
          Type={Type}
          registrationType={registrationType}
          partyType={partyType}
        />
      ) : (
        ((companyType==1 ||(data?.taxability?.value!="" && (partyType==="CUSTOMER" || Type==="Pos")) || (partyType==="SUPPLIER" && data?.taxability?.value==="" && data?.partyCategory==="RBCS") ||(partyType==="SUPPLIER" && data?.taxability?.value!=="" && data?.partyCategory!="RBCS")) && 
        <JournalEntry
          journalEntry={journalEntry}
          totCdtAmt={totCdtAmt}
          totDbtAmt={totDbtAmt}
          Type={Type}
          invTransArr={invTransArr}
          paymentTransArr={paymentTransArr}
          partyType={partyType}
          registrationType={registrationType}
          modalEvent={false}
          data={data}
          setData={setData}
        />)
      )}
      <InvoiceJournalEntryModal
        open={openJournalEntry}
        setOpen={setOpenJournalEntry}
        journalEntry={journalEntry}
        totCdtAmt={totCdtAmt}
        totDbtAmt={totDbtAmt}
        Type={Type}
        invTransArr={invTransArr}
        paymentTransArr={paymentTransArr}
        partyType={partyType}
        registrationType={registrationType}
        modalEvent={true}
        data={data}
        setData={setData}
      />
    </Box>
  );
}

export default HsnandJournalTab;
